import { NavLink } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { navigationItems } from '../../config/navigation';
import { canAccess } from '../../config/accessControl';
import { useAuth } from '../../context/AuthContext';
import { classNames } from '../../utils/classNames';

function SidebarNavigation({ collapsed = false, onNavigate, theme = 'dark' }) {
  const { user, activeCampaign } = useAuth();
  const visibleItems = navigationItems.filter((item) =>
    canAccess(user, item.roles, item.permission)
  );

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className={classNames(
        'mx-3 mb-3 rounded-card border',
        theme === 'dark' ? 'border-white/10 bg-white/[0.06]' : 'border-border bg-slate-50',
        collapsed ? 'p-2' : 'p-3'
      )}>
        <div className={classNames('flex items-center', collapsed ? 'justify-center' : 'gap-3')}>
          <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-primary-400/15 text-primary-300">
            <Megaphone className="size-4" aria-hidden="true" />
          </span>
          {!collapsed && (
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-wider text-content-muted">Campaña activa</p>
              <p className={classNames('truncate text-sm font-medium', theme === 'dark' ? 'text-slate-200' : 'text-content-primary')}>{activeCampaign?.name || 'Cargando campaña...'}</p>
            </div>
          )}
        </div>
      </div>

      <nav className="flex-1 space-y-1 overflow-y-auto px-3 pb-4" aria-label="Navegación principal">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onNavigate}
              title={collapsed ? item.name : undefined}
              className={({ isActive }) =>
                classNames(
                  'group flex h-10 items-center rounded-control text-sm font-medium transition',
                  collapsed ? 'justify-center px-2' : 'gap-3 px-3',
                  isActive
                    ? theme === 'dark'
                      ? 'bg-primary-400/15 text-primary-200'
                      : 'bg-primary-50 text-primary-800'
                    : theme === 'dark'
                      ? 'text-slate-400 hover:bg-white/[0.06] hover:text-slate-100'
                      : 'text-content-secondary hover:bg-slate-100 hover:text-content-primary'
                )
              }
            >
              <Icon className="size-[18px] shrink-0" aria-hidden="true" />
              {!collapsed && <span className="truncate">{item.name}</span>}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}

export default SidebarNavigation;
